<template>
  <div>
    <logged-in-header />
    <inventories-and-refills-panel />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import inventoriesAndRefillsPanel from "../components/inventories-refills/InventoriesAndRefillsPanel";

export default {
  components: {
    loggedInHeader,
    inventoriesAndRefillsPanel
  }
};
</script>
